module.exports = __webpack_public_path__ + "media/images/Down-arrow-f983c252181f0debe7026d8d9821bbb8.svg";